<template lang="">
  <div>
    <!-- {{ getAttachmentsTypes }} -->

    <b-card no-body>
      <div class="m-2">
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label class="mr-1">Zeige</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-1"
              style="min-width: 80px; max-width: 100px;"
            />
            <label class="ml-1">Einträge</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="filter"
                class="d-inline-block mr-1"
                placeholder="Suche..."
                type="search"
              />
              <!--  -->
              <!-- Sidebar -->
              <!--  -->
              <b-button
                variant="primary"
                type="button"
                @click="createNewObject()"
              >
                <span class="text-nowrap">Type hinzufügen</span>
              </b-button>

              <b-sidebar
                id="sidebarAttachment-right"
                bg-variant="white"
                right
                backdrop
                shadow
                no-header
              >
                <sidebar-content />
              </b-sidebar>
              <b-sidebar
                id="sidebarAttachment-right-edit"
                bg-variant="white"
                right
                backdrop
                shadow
                no-header
              >
                <sidebar-content
                  :id="editAttachmentTypeData.id"
                  :is-edit-mode="isEditMode"
                  :edit-attachment-type-entry="editAttachmentTypeData"
                  @update-event="getTotalRows"
                />
              </b-sidebar>
            </div>
          </b-col>
        </b-row>
      </div>
      <div>
        <b-card no-body>
          <b-table
            ref="refListTable"
            striped
            hover
            responsive
            :items="getAttachmentsTypes"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            show-empty
            empty-text="Keine Einträge gefunden"
            @row-clicked="onRowClicked"
          >
            <template #cell(actions)="data">
              <b-dropdown
                variant="link"
                no-caret
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>

                <b-dropdown-item @click="editObject(data)">
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">Bearbeiten</span>
                </b-dropdown-item>

                <b-dropdown-item
                  :disabled="data.item.attachments.length !== 0"
                  @click="deleteWarning(data)"
                >
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">Löschen</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-card>
      </div>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span
              class="text-muted"
            >Zeige {{ dataMeta.from }} bis {{ dataMeta.to }} von
              {{ dataMeta.of }} Einträge</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="getTotalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BTable,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BPagination,
  BBadge,
  BDropdown,
  BDropdownItem,
  BLink,
  BSidebar,
  VBToggle,
  BImg,
} from 'bootstrap-vue'

import tableHelper from '@/views/pages/Table+Helper'
import helper from '@/helper/helper'
import vSelect from 'vue-select'
import API from '@/service/api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import SidebarContent from './SettingsAddNewAttachmentType.vue'

export default {
  setup() {
    const { getFormattedDate } = helper()

    const {
      perPageOptions,
      perPage,
      filter,
      totalRows,
      currentPage,
      refListTable,
      dataMeta,
      refetchData,
    } = tableHelper()

    return {
      perPageOptions,
      perPage,
      filter,
      totalRows,
      currentPage,
      refListTable,
      dataMeta,
      getFormattedDate,
      refetchData,
      baseURL: API().defaults.baseURL,
    }
  },
  components: {
    BCard,
    BTable,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BPagination,
    BBadge,
    BDropdown,
    BDropdownItem,
    BLink,
    BSidebar,
    SidebarContent,
    VBToggle,
    BImg,
    vSelect,
    ToastificationContent,
  },

  directives: {
    'b-toggle': VBToggle,
  },

  data() {
    return {
      fields: [
        // {
        //   key: 'id',
        //   label: 'ID',
        //   sortable: true,
        // },
        {
          key: 'attachmentType',
          label: 'Dokumententyp',
          sortable: true,
        },
        {
          key: 'description',
          label: 'Beschreibung',
          sortable: true,
        },
        {
          key: 'attachments.length',
          label: '# Dokumente',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Aktionen',
        },
      ],
      sortBy: 'id',
      sortDesc: false,
      isEditMode: false,
      refListTable: null,
      editAttachmentTypeData: [],
    }
  },
  computed: {
    // get storages types
    getAttachmentsTypes() {
      return this.$store.getters.getAttachmentsTypes
    },
    getTotalRows() {
      return this.getAttachmentsTypes.length
    },
  },
  updated() {
    this.totalRows = this.getTotalRows
  },
  methods: {
    // create new object
    createNewObject() {
      this.isEditMode = false
      this.$root.$emit('bv::toggle::collapse', 'sidebarAttachment-right')
    },

    editObject(data) {
      this.editAttachmentTypeData = data.item
      this.isEditMode = true
      this.$root.$emit('bv::toggle::collapse', 'sidebarAttachment-right-edit')
    },

    deleteWarning(data) {
      this.$swal({
        title: 'Bist du sicher?',
        // text: 'Das Lager wird unwiederruflich gelöscht.',
        text: `Das Dokumententyp "${data.item.attachmentType}" wirklich löschen?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, löschen!',
        cancelButtonText: 'Abbrechen',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch('deleteAttachmentType', data.item.id)
            .then(() => {
              this.$store.dispatch('getAttachmentsTypes')
              this.toastNotification(
                'Dokumententyp erfolgreich gelöscht.',
                'CheckIcon',
                'success'
              )
            })
            .catch(() => {
              this.toastNotification(
                'Dokumententyp konnte nicht gelöscht werden.',
                'AlertTriangleIcon',
                'danger'
              )
            })
        }
      })
    },

    toastNotification(title, icon, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
